import { useCallback, useState } from 'react';
import { useClickInteractionListener } from '@thd-olt-functional/utils';
import { PRODUCT_POD_V7_CLICK } from '../util';

export const useProductPodClickTracker = ({ itemId, position }) => {
  const productClickData = {
    podAction: 'product pod',
    podAnchorSku: itemId,
    target: '_self',
    parent: 'plp'
  };

  const sendAnalytics = () => {
    if (typeof window === 'undefined') return;
    const lifeCycleEventBus = window.LIFE_CYCLE_EVENT_BUS;
    if (lifeCycleEventBus && typeof lifeCycleEventBus.trigger === 'function') {
      lifeCycleEventBus.trigger(PRODUCT_POD_V7_CLICK, productClickData);
    }
  };

  const useNodeRef = () => {
    const [node, setNode] = useState(null); // <HTMLElement | null>

    /**
     * Callback ref to be called by React whenever the ref gets attached
     * to a different node or becomes null.
     * @see https://legacy.reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
     */
    const callbackRef = useCallback((value) => {
      setNode(value);
    }, []);

    return [callbackRef, node];
  };

  const [productPodNodeRef, productPodeNode] = useNodeRef();

  useClickInteractionListener({
    callbackFn: sendAnalytics,
    targetNode: productPodeNode,
    itemId,
    sponsoredId: itemId,
    trackSource: '',
    slotId: '',
    position,
    plaLocation: ''
  });

  return productPodNodeRef;
};